import {
  BalanceService,
  OrderService,
  TradingDataService,
  PositionsService,
  OrderBookService,
  BestBidOfferService,
  TradeHistoryService
} from '@trading/core'
import {
  BalanceRepoWs,
  BestBidOfferRepoWs,
  OrderApiWs,
  OrderBookRepoWs,
  PositionApiWS,
  TradeHistoryApiWs,
  TradingDataWS,
  WebSocketConnectionManager
} from '@trading/infrastructure'
import { setStreamingConnectionProvider } from '~~/datafeeds/udf/src'
import { api } from '~/services/composition'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  const wsManager: WebSocketConnectionManager = new WebSocketConnectionManager({
    baseUrl: useEndpoints().wsBase,
    getPrivateToken: async () => {
      // TODO потом заменить на auth store / cookie / session
      const token = await useAuthStore().getToken()
      if (!token) return ''
      return token
    }
  })

  setStreamingConnectionProvider(() => wsManager.getConnection('public'))

  const balanceRepoWs = new BalanceRepoWs(wsManager)
  const orderApiRepoWs = new OrderApiWs(wsManager)
  const orderBookRepoWs = new OrderBookRepoWs(wsManager)
  const bestBidOfferRepoWs = new BestBidOfferRepoWs(wsManager)
  const tradingDataRepoWs = new TradingDataWS(wsManager)
  const positionsRepoWs = new PositionApiWS(wsManager)
  const tradeHistoryRepoWs = new TradeHistoryApiWs(wsManager)

  const balanceService = new BalanceService(balanceRepoWs)
  const orderService = new OrderService(api.orders, orderApiRepoWs)
  const orderBookService = new OrderBookService(orderBookRepoWs)
  const bestBidOfferService = new BestBidOfferService(bestBidOfferRepoWs)
  const positionsService = new PositionsService(api.history, api.positions, positionsRepoWs)
  const tradingDataService = new TradingDataService(tradingDataRepoWs)
  const tradeHistoryService = new TradeHistoryService(tradeHistoryRepoWs)

  nuxtApp.hook('auth:logout', () => {
    try {
      wsManager.close()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // Ошибки в процессе сброса и отписки не должны препятствовать выходу из системы
    }
  })

  return {
    provide: {
      wsManager,
      wsBalanceService: balanceService,
      wsOrderService: orderService,
      wsPositionService: positionsService,
      wsTradingDataService: tradingDataService,
      wsOrderBookService: orderBookService,
      wsBestBidOfferService: bestBidOfferService,
      wsTradeHistoryService: tradeHistoryService
    }
  }
})
